import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as UserActions from "Data/users/UserActions";

import InviteCard from "Components/InviteCard";

class InviteController extends React.Component
{
    state = {
        busy: true,
        invite: false
    };

    static propTypes = {
        token: PropTypes.string.isRequired,
        fetchInvite: PropTypes.func.isRequired,
        acceptInvite: PropTypes.func.isRequired,

        invite: PropTypes.object
    };

    onSubmit = (data) => {
        this.props.acceptInvite(
            this.props.token,
            data.fullname,
            data.password
        )
    };

    componentDidMount()
    {
        this.props.fetchInvite(this.props.token)
            .then(invite => {
                this.setState({
                    busy: false,
                    invite: invite
                });
            })
            .catch(() => {
                this.setState({busy: false})
            });
    }

    render()
    {
        return <div className="flex h-full items-center justify-center bg-indigo-800">
            { this.renderCard() }
        </div>
    }

    renderCard()
    {
        if (this.state.busy) {
            return null;
        }

        if (! this.state.invite) {
            return <div className='text-white'>Invite not found.</div>;
        }

        return <InviteCard onSubmit={this.onSubmit} />;
    }
}

const mapStateToProps = (state, ownProps) => ({
    token: ownProps.match.params.token,
    invite: _.find(state.invites, invite => invite.token === ownProps.match.params.token)
});

const mapDispatchToProps = {
    fetchInvite: UserActions.fetchInvite,
    acceptInvite: UserActions.acceptInvite
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InviteController);
